import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { P404Component } from './admin/views/error/404.component';
import { ApplyComponent } from './apply/apply.component';
import { Roles } from './config/enums/roles';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { OnboardingComponent } from './onboarding/onboarding.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { TenantComponent } from './tenant/tenant.component';
import { AuthGuard } from './_helpers';
import { PendingChangesGuard } from './_helpers/pending-changes.guard';
import { TenantAuthGuard } from './_helpers/tenant.auth.guard';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'home', component: HomeComponent },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'confirmRegistration',
    component: OnboardingComponent,
    canDeactivate: [PendingChangesGuard],
  },
  {
    path: 'resetPassword',
    component: ResetPasswordComponent,
    canDeactivate: [PendingChangesGuard],
  },
  {
    path: ':tenantSubDomainName/login',
    canActivate: [TenantAuthGuard],
    component: LoginComponent,
  },
  {
    path: ':tenantSubDomainName/apply',
    canActivate: [TenantAuthGuard],
    component: ApplyComponent,
  },
  {
    path: ':tenantSubDomainName/forgotPassword',
    canActivate: [TenantAuthGuard],
    component: ForgotPasswordComponent,
  },
  {
    path: ':tenantSubDomainName/admin',
    canActivate: [AuthGuard],
    data: {
      roles: [Roles.staff, Roles.admin, Roles.superAdmin, Roles.tenantManager],
    },
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminModule),
  },
  {
    path: ':tenantSubDomainName/portal',
    canActivate: [AuthGuard],
    data: { roles: [Roles.student] },
    loadChildren: () =>
      import(`./studentPortal/student.portal.module`).then(
        (m) => m.StudentPortalModule
      ),
  },
  {
    path: ':tenantSubDomainName',
    component: TenantComponent,
  },
  {
    path: '**',
    component: P404Component,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
